import { render, staticRenderFns } from "./NotenartruecknahmeSV.vue?vue&type=template&id=03249e33&"
import script from "./NotenartruecknahmeSV.vue?vue&type=script&lang=js&"
export * from "./NotenartruecknahmeSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports